/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react"
import PropTypes from "prop-types"
import { useStaticQuery, graphql } from "gatsby"

import Header from "./header"
import "./layout.css"
import Footer from "./Footer"
import MyProvider from "./Provider"

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `)

  return (
    <MyProvider>
      <div className="relative z-10 w-screen h-full flex flex-col stars bg-orbitalPrimary bg-opacity-50">
        <div className="twinkling h-auto bg-orbitalPrimary bg-opacity-50">
          <div className="bg-orbitalPrimary bg-opacity-10">
            <Header siteTitle={data.site.siteMetadata.title} />
          </div>
          <main className="bg-orbitalPrimary bg-opacity-10 flex flex-col gap-32">
            {children}
          </main>
          <div className="bg-orbitalPrimary bg-opacity-10">
            <Footer />
          </div>
        </div>
      </div>
    </MyProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
